// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7241bcf3","796":"93d8337e"}[chunkId] + ".chunk.js";
};